/* istanbul ignore file -- just a list of URLs */
export const vipOrderUrls = {
  access: '/system/ajax/stickybar/VipAccessJson',
  accessConsultant: (consultantNumber: string) =>
    `/system/ajax/VipShopping/AccessConsultant?consultantNumber=${consultantNumber}`,
  accessSwitch: (consultantNumber: number) =>
    `/system/ajax/StickyBar/VipAccessSwitch?ConsultantNumber=${consultantNumber}`,
  accessSwitchValidate: (consultantNumber: string) =>
    `/system/ajax/StickyBar/VipAccessSwitchValidate?ajaxId=69&related%5BConsultantNumber%5D=${consultantNumber}&activeInput=ConsultantNumber&ConsultantNumber=${consultantNumber}`,
  basket: '/shopping/basket',
  consultantNumbers: (hint: string) => `/system/ajax/VipShopping/GetConsultantNumbers?hint=${hint}`,
};
